/**
 * This method should typically only be used in display helpers, not directly in a component
 */
const titleize = (input: string) =>
  input.replace(/_/g, ' ').replace(/(?:^|\s|-)\S/g, (x) => x.toUpperCase());

export default titleize;
